export default __webpack_public_path__ + "static/media/Pterodactilo.d743ebf7.png";